import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Endpoints (relative to /api) whose GET requests should auto-include project_id
const PROJECT_SCOPED_GET = [
  "/pos",
  "/pos/stats",
  "/pos/approval-summary",
  "/outward",
  "/outward/stats",
  "/stock",
  "/stock/adjustments",
  "/transfers",
];

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (method === "get") {
    const url = (config.url || "").split("?")[0];
    const scoped = PROJECT_SCOPED_GET.some(
      (p) => url === p || url.startsWith(p + "?") || url.startsWith(p + "&")
    );
    if (scoped) {
      const projectId = localStorage.getItem("rrl.activeProjectId");
      if (projectId) {
        config.params = config.params || {};
        if (config.params.project_id === undefined) {
          config.params.project_id = projectId;
        }
      }
    }
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
